<template>
    <div v-loading.fullscreen.lock="loading">
        <car-use-search-bar-component
            add_auth="新增公务车使用申请"
            :Allenterprise="Allenterprise"
            :AllStaff="AllStaff"
            @search="get_car_use_index"
            @addTeam="addTeam"
        ></car-use-search-bar-component>
        <common-table-component
            details_auth="公务车使用申请详情"
            :col_arr="fcol_arr"
            :table_data="ftable_data"
            @details_row="details_car_use"
            table_height="549px"
        ></common-table-component>
        <common-page-component
            :current_page="cond.page"
            :page_size="cond.limit"
            :total="ftotal"
            @search="get_car_use_index"
        ></common-page-component>
        <car-use-edit-component            
            :id="fid"
            :show_type="edit_type"
            :dialogFormVisible="fdialogFormVisible"
            :car_use_details_data="car_use_details_data"
            :edit_auth="edit_auth"
            :del_auth="del_auth"
            :add_file_auth="add_file_auth"
            :to_approval_auth="to_approval_auth"
            :sel_approval_auth="sel_approval_auth"
            :ApprovalAuth="ApprovalAuth"
            :withdraw_auth="withdraw_auth"
            print_auth="打印公务车使用申请"
            :AllStaff="AllStaff"
            :enterprise_department="enterprise_department"
            @show_edit="show_edit"
            @addTeam="addTeam"
            @search="get_car_use_index"
            @exitDialog="dialogExit"
            @frefresh="frefresh"
            @details_row="details_car_use"
        ></car-use-edit-component>
    </div>
</template>

<script>
import { car_use_index_request,car_use_details_request} from '@/network/hrm/CarUse.js'
import { staff_list_request,enterprise_list_request } from '@/network/list.js'
import { enterprise_department_request} from '@/network/enterprise.js'

import CarUseSearchBarComponent from '@/components/hrm/CarUse/CarUseSearchBarComponent'
import CommonTableComponent from '@/components/common/CommonTableComponent'
import CommonPageComponent from '@/components/common/CommonPageComponent'
import CarUseEditComponent from '@/components/hrm/CarUse/CarUseEditComponent'

export default {
    name:'',
    data(){
        return {
            fid: 0,
            edit_type: 0,
            loading: false,
            fdialogFormVisible: false,
            cond: {
                enterprise_id: '',
                staff_id: '',
                page: 1,
                limit: 10,
            },
            ftotal: 0,
            ftable_data: [],
            fcol_arr: [   
                {
                    prop: 'state',
                    label: '审批状态',
                    minWidth: '100px',
                    tag: (d) => {
                        if(d===0) {
                            return {
                                type: 'info',
                                filter_data: '待提交'
                            }
                        } else if(d===1) {
                            return {
                                type: '',
                                filter_data: '审批中'
                            }
                        } else if(d===2) {
                            return {
                                type: 'success',
                                filter_data: '已通过'
                            }
                        } else if(d===3) {
                            return {
                                type: 'danger',
                                filter_data: '已驳回'
                            }
                        }
                    }
                },
                {
                    prop: 'start_time',
                    label: '使用时间',
                    minWidth: '180px',
                },
                {
                    prop: 'end_time',
                    label: '预计归还时间',
                    minWidth: '180px',
                },
                {
                    prop: 'staff_name',
                    label: '申请人',
                    minWidth: '100px',
                },
                {
                    prop: 'department_name',
                    label: '申请部门',
                    minWidth: '120px'
                },
                {
                    prop: 'enterprise_name',
                    label: '所属企业',
                    minWidth: '120px'
                },{
                    prop: 'current_examine_staff_name',
                    label: '当前审批人',
                    minWidth: '100px',
                },
            ],
            car_use_details_data: {},
            edit_auth: false,
            del_auth: false,
            //补充附件
            add_file_auth: false,
            //提交
            to_approval_auth: false,
            //查看审批
            sel_approval_auth: false,
            //审批
            ApprovalAuth: false,
            //撤回审批
            withdraw_auth: false,
            AllStaff: [],
            Allenterprise: [],
            enterprise_department: []
        }
    },
    computed:{},
    methods:{
        get_car_use_index(param = {}) {
            this.loading = true
            this.cond.enterprise_id = param.enterprise_id ?? this.cond.enterprise_id
            this.cond.staff_id = param.staff_id ?? this.cond.staff_id
            this.cond.page = param.page ?? this.cond.page
            if (param.limit) {
                this.cond.limit = param.limit
                this.cond.page = 1
            }
            car_use_index_request(this.cond)
                .then((s) => {
                    this.loading = false
                    if (s.status === 0) {
                        this.ftable_data = s.result.data
                        this.ftotal = s.result.total
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.loading = false
                    this.$message.error(err)
                })
        },
        details_car_use(id) {
            this.fid = id
            this.fdialogFormVisible = true
            car_use_details_request(id)
                .then((s) => {
                    if (s.status === 0) {
                        this.car_use_details_data = s.result
                        //权限判断
                        this.is_auth(s.result)
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        addTeam() {
            this.edit_type = 1
            this.fdialogFormVisible = true
        },
        show_edit() {
            this.edit_type = 2
        },
        dialogExit() {
            this.fdialogFormVisible = false
            this.fid = 0
            this.edit_type = 0
        },
        frefresh() {
            this.details_car_use(this.fid)
            this.get_car_use_index()
        },
        is_auth(res) {
            this.edit_auth = false
            this.del_auth = false
            this.add_file_auth = false
            this.to_approval_auth = false
            this.sel_approval_auth = false
            this.ApprovalAuth = false
            this.withdraw_auth = false

            if(res.state === 0) {
                //判断创建人是否为自己
                if(res.create_staff === this.$store.state.user.id) {
                    this.to_approval_auth = this.$_has('提交公务车使用申请')
                    this.edit_auth = this.$_has('修改公务车使用申请')
                    this.del_auth = this.$_has('删除公务车使用申请')
                }
            } else if(res.state === 1) {
                 //判断创建人或申请人是否为自己
                if(res.create_staff === this.$store.state.user.id) {
                    this.withdraw_auth = this.$_has('撤回公务车使用申请')
                    this.add_file_auth = this.$_has('补充公务车使用申请附件')
                }
                //判断当前审批人是否为自己
                if(res.current_examine_staff_id === this.$store.state.user.id) {
                    this.ApprovalAuth = this.$_has('审批公务车使用申请')
                }
                this.sel_approval_auth = this.$_has('查看公务车使用申请审批记录')
            } else if(res.state === 2) {
                if((res.staff_id === this.$store.state.user.id) || (res.create_staff === this.$store.state.user.id)) {
                    this.add_file_auth = this.$_has('补充公务车使用申请附件')
                }
                this.sel_approval_auth = this.$_has('查看公务车使用申请审批记录')
            } else if(res.state === 3) {
                //判断创建人或申请人是否为自己
                if(res.create_staff === this.$store.state.user.id) {
                    this.to_approval_auth = this.$_has('提交公务车使用申请')
                    this.edit_auth = this.$_has('修改公务车使用申请')
                    this.del_auth = this.$_has('删除公务车使用申请')
                }
                this.sel_approval_auth = this.$_has('查看公务车使用申请审批记录')
            }
        },
        get_all_staff() {
            staff_list_request()
                .then((s) => {
                    if (s.status === 0) {
                        this.AllStaff = s.result
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.$message.error(err)
                })
        },
        get_all_enterprise() {
            enterprise_list_request()
                .then((s) => {
                    this.Allenterprise = s.result
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        get_enterprise_department() {
            this.loading = true
            enterprise_department_request()
                .then((s) => {
                    this.loading = false
                    if (s.status === 0) {
                        this.enterprise_department = s.result
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.loading = false
                    this.$message.error(err)
                })
        },
    },
    filters:{},

    props:{},
    created(){
        this.get_car_use_index()
        this.get_all_staff()
        this.get_all_enterprise()
        this.get_enterprise_department()
    },
    destoryed(){},
    mounted(){},
    updated(){},
    components:{
        CarUseSearchBarComponent,
        CommonTableComponent,
        CommonPageComponent,
        CarUseEditComponent
    },
    watch:{}
}
</script>

<style lang='less'></style>